import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=559482e9&"
import script from "./FormHeader.vue?vue&type=script&lang=ts&"
export * from "./FormHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('559482e9')) {
      api.createRecord('559482e9', component.options)
    } else {
      api.reload('559482e9', component.options)
    }
    module.hot.accept("./FormHeader.vue?vue&type=template&id=559482e9&", function () {
      api.rerender('559482e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GoodsReceiptPrice/FormHeader.vue"
export default component.exports